 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		43: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"3":"component---src-pages-de-ch-aktuelles-befluegeltes-leiden-buch-tsx","4":"component---src-pages-de-ch-aktuelles-index-tsx","5":"component---src-pages-de-ch-aktuelles-reise-durch-polen-tsx","6":"component---src-pages-de-ch-aktuelles-todesanzeige-tsx","7":"component---src-pages-de-ch-beitraege-behauptung-tsx","8":"component---src-pages-de-ch-beitraege-einige-worte-ueber-wandmalereien-tsx","9":"component---src-pages-de-ch-beitraege-index-tsx","10":"component---src-pages-de-ch-galerie-ausstellungen-tsx","11":"component---src-pages-de-ch-index-tsx","12":"component---src-pages-de-ch-kontakt-tsx","13":"component---src-pages-de-ch-rechtliche-hinweise-tsx","14":"component---src-pages-de-ch-sitemap-tsx","15":"component---src-pages-de-ch-wandmalereien-index-tsx","16":"component---src-pages-de-ch-willkommen-tsx","17":"component---src-pages-de-ch-zur-person-auszeichnung-monte-carlo-tsx","18":"component---src-pages-de-ch-zur-person-im-atelier-tsx","19":"component---src-pages-de-ch-zur-person-index-tsx","20":"component---src-pages-de-ch-zur-person-kulturpreis-der-stadt-zabrze-tsx","21":"component---src-pages-de-ch-zur-person-lebenslauf-tsx","22":"component---src-pages-index-tsx","23":"component---src-pages-pl-pl-aktualnosci-index-tsx","24":"component---src-pages-pl-pl-aktualnosci-posmiertny-tsx","25":"component---src-pages-pl-pl-aktualnosci-uskrzydlone-cierpienie-ksiazka-tsx","26":"component---src-pages-pl-pl-aktualnosci-z-podrozy-po-polsce-tsx","27":"component---src-pages-pl-pl-galeria-wystawy-tsx","28":"component---src-pages-pl-pl-index-tsx","29":"component---src-pages-pl-pl-kontakt-tsx","30":"component---src-pages-pl-pl-malarstwo-scienne-index-tsx","31":"component---src-pages-pl-pl-mapa-strony-tsx","32":"component---src-pages-pl-pl-odnosnie-osoby-index-tsx","33":"component---src-pages-pl-pl-odnosnie-osoby-nagroda-kultury-miasta-zabrze-tsx","34":"component---src-pages-pl-pl-odnosnie-osoby-w-pracowni-tsx","35":"component---src-pages-pl-pl-odnosnie-osoby-wyroznienie-w-monte-carlo-tsx","36":"component---src-pages-pl-pl-odnosnie-osoby-zyciorys-tsx","37":"component---src-pages-pl-pl-wkladki-index-tsx","38":"component---src-pages-pl-pl-wkladki-kilka-slow-o-malarstwie-sciennym-tsx","39":"component---src-pages-pl-pl-wkladki-twierdzenie-tsx","40":"component---src-pages-pl-pl-wskazowki-prawne-tsx","41":"component---src-pages-pl-pl-zaprasza-tsx","42":"component---src-pages-styleguide-index-tsx"}[chunkId]||chunkId) + "-" + {"3":"ef3e127840ab9c4dedcf","4":"02e997e7b4b85dea7efc","5":"9e5e0b07a63373162e6e","6":"35d65d0602bcf3317e83","7":"eb51d3d91dc28b223f3f","8":"469d7329cd25c32d6566","9":"b96b579c30377f608e7d","10":"18ec0b13b384547fc704","11":"06d67c5b30df4d718404","12":"7c383424958d5fcc3f92","13":"025a97e18aaef8e2d735","14":"0eac9f23e45a59baa485","15":"40fd86caad26c9d6c682","16":"d48c2cda884d0682d80d","17":"e36a513d92de1ebf769f","18":"0eacf5792c2bb67a464b","19":"d82c33a81bdce66e1532","20":"301c7f002335e9c58864","21":"acd7c7800ff6dcdda744","22":"788680bf8acb7e48a35e","23":"8665efac86dc54d80bb2","24":"c06220a6122634027846","25":"c13ed8c7ae0349129cb1","26":"3ba9f6682c78a7d51e37","27":"961894cd5f0c5eb7574a","28":"773fec6711b22bbbb425","29":"1c9992c53dc0a02cdc6f","30":"a81b4506d15b8cde8465","31":"4bbc5f748101d93a6eb1","32":"14cc0a1e22f76881df2e","33":"bce0ef67d68a3702f6ad","34":"682750225f4f356ac8fb","35":"004735d13c4f3e959336","36":"5563701912804980d0c3","37":"fc98d82bda08e28fa4c2","38":"db2573f7b633b84e52a3","39":"87cbbfe5182ab7631e61","40":"d67d21df6474b99cbf31","41":"fdde1aeb08297fbc560c","42":"d85a40ce4be15b0e37b4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
